import { PlanFrequency } from '../constants'

export const getCardsByFrequency = <C extends { offer: { frequency?: string | null } }>(
  cards?: readonly C[]
) => {
  if (!cards || !cards.length) return { monthlyCards: [], yearlyCards: [] }

  const monthlyCards = cards.filter((card) => card.offer.frequency === PlanFrequency.MONTHLY)
  const yearlyCards = cards.filter((card) => card.offer.frequency === PlanFrequency.YEARLY)

  return { monthlyCards, yearlyCards }
}
